
import { h, Component } from 'preact';
import style from './style.less'
import dayjs from 'lib/helpers/dayjs';

export default class SquareImage extends Component {
	constructor(){
        super()
        this.state = {
			fontSize: '1'
		}
		this.handleRef = this.handleRef.bind(this)
    }

    componentDidMount(){
        if(this.container.offsetWidth){
            this.setState({
                fontSize: this.container.offsetWidth / 3
            })
        }
    }

    handleRef(ref){
        this.container = ref
    }

    render(){
        let outerStyle = {
            backgroundImage:`url(${this.props.image})`,
            minWidth: `${this.props.minWidth}`,
            maxWidth: `${this.props.maxWidth}`,
            fontSize: this.state.fontSize,
            height: this.state.fontSize * 3,
        }
    
        return (
            <div ref={this.handleRef} class={style.imageContainer} style={outerStyle} >
                {!this.props.image &&
                    <FAUserCircleO style={{fontSize: '2em'}} />
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/elements/SquareImage/index.js